import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { getimagepath } from '../utils/verticalAssets';

export class AutoSuggestInput extends Component {
  state = {
    show: false,
    value: this.props.value,
    properties: this.props.properties || ['meter', 'address', 'discoId'],
    suggestions: [],
    currentService: this.props.currentService,
  };

  selectSuggestion = (obj) => {
    this.setState({ show: false, value: obj[this.state.properties[0]] });
    this.props.onSelect(obj);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  focusIn = () => {
    this.setState({ suggestions: this.props.data, show: true });
  };

  focusOut = (e) => {
    e.preventDefault();
    setTimeout(() => this.setState({ show: false }), 100);
  };

  searchSuggestions = (e) => {
    const { value } = e.target;
    const { data } = this.props;
    const [headProp, bodyProp] = this.state.properties;

    // Send value to parent component first
    this.props.onChange(e);

    this.setState({ value });

    // If input is empty, show all suggestions
    if (!value) {
      this.setState({ suggestions: data, show: true });
      return;
    }

    // Start suggestions filtering logic
    const suggestions = data.filter((d) => {
      // Search for input value in header string or body string to determine suggesgtions
      if (
        (String(d[headProp]).includes(value) ||
          String(d[bodyProp]).match(new RegExp(value, 'gi'))) &&
        d[headProp] !== value
      ) {
        return true;
      }
      return false;
    });

    this.setState({ show: true, suggestions });
  };

  getCurrentService() {
    const { currentService } = this.props;
    switch (currentService) {
      case 'data':
      case 'airtime':
        return 'Phone';
      case 'cable':
        return 'Cable TV';
      default:
        return 'Meter';
    }
  }

  filterSuggestions() {
    if (this.state.currentService === 'cable') {
      return this.state.suggestions.filter((suggestion) =>
        ['GOTV', 'STARTIMES', 'DSTV'].includes(suggestion.disco.toUpperCase())
      );
    }

    if (
      this.state.currentService === 'airtime' ||
      this.state.currentService === 'vtu' ||
      this.state.currentService === 'data'
    ) {
      return this.state.suggestions.filter((suggestion) =>
        ['MTN', 'AIRTEL', '9MOBILE'].includes(suggestion.disco.toUpperCase())
      );
    }

    if (this.state.currentService === 'electricity') {
      return this.state.suggestions.filter(
        (suggestion) =>
          !['MTN', 'AIRTEL', '9MOBILE', 'GOTV', 'STARTIMES', 'DSTV'].includes(
            suggestion.disco.toUpperCase()
          )
      );
    }
  }

  render() {
    const { properties, type, showAddBtn } = this.props;
    let { show } = this.state;
    let filterSuggestions = this.filterSuggestions();

    return (
      <div style={{ marginBottom: 20 }}>
        <div className="input-container">
          {showAddBtn ? (
            <span
              className="input-addon"
              onClick={() => {
                this.setState({ value: '' });
                document.getElementById('meterNo').focus();
              }}
            >
              + Add New {this.getCurrentService()}
            </span>
          ) : null}
          <input
            id="meterNo"
            name={properties[0]}
            autoComplete="off"
            type={type || 'text'}
            value={this.state.value}
            onChange={this.searchSuggestions}
            onFocus={this.focusIn}
            onBlur={this.focusOut}
          />
        </div>

        {filterSuggestions.length > 0 ? (
          <div
            style={{ marginTop: '0px' }}
            className={`autosuggest autosuggest-container ${show ? 'dropdown' : 'closeup'}`}
          >
            {filterSuggestions.map((s) => (
              <div
                className="autosuggest-line"
                key={s[properties[0]]}
                onClick={() => this.selectSuggestion(s)}
                onMouseDown={() => this.selectSuggestion(s)}
              >
                {s.disco ? <div>
                  {/* const image = getimagepath(service_provider); */}
                  <img
                    src={getimagepath(s.disco === 'BH' ? 'ABUJA' : s.disco)}
                    alt=""
                    style={{
                      width: '36px',
                      height: '36px',
                      objectFit: 'contain',
                      maxWidth: '100%',
                      maxHeight: '100%',
                    }}
                  />
                </div> : <Fragment></Fragment>}
                <div style={{ width: '100%' }}>
                  <div className="autosuggest-header">
                    <span>{s[properties[0]]}</span>
                  </div>
                  <div className="autosuggest-body">{s[properties[1]]}</div>
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentService: state.order.currentService,
  };
};

export default connect(mapStateToProps)(AutoSuggestInput);



// WEBPACK FOOTER //
// ./src/components/AutoSuggestInput.js